// Time for the browser to start the download before its URL is revoked: Safari drops a download
// whose blob URL is revoked in the same tick as the click.
const REVOKE_AFTER_MS = 1000;

/** Save `body` as a pretty-printed JSON file named `name`. */
export function downloadJson(name, body) {
  const url = URL.createObjectURL(new Blob([JSON.stringify(body, null, 2)], { type: 'application/json' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  // Attached, since some browsers ignore a click on a detached anchor.
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), REVOKE_AFTER_MS);
}
